import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
/**
 * This hook returns pageState from Sitecore Context
 * @returns {string} Current pageState
 */
var usePageState = function () {
    var sitecoreContext = useSitecoreContext().sitecoreContext;
    return sitecoreContext.pageState;
};
export default usePageState;
